import React from "react";
import { Controller, Control, FieldPath, FieldValues } from "react-hook-form";
import RadioButton from "./RadioButton";
import styles from "./RadioButton.module.scss";

interface RadioOption {
  value: string;
  label: string;
}

interface Props<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  options: RadioOption[];
  label?: string;
  rules?: any;
}

const RadioButtonGroup = <T extends FieldValues>({
  name,
  control,
  options,
  label,
  rules,
}: Props<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div className={styles.radioButtonGroup}>
          {label && <label className="form-label">{label}</label>}
          <div className="radio-group">
            {options.map((option, index) => (
              <RadioButton
                key={index}
                label={option.label}
                value={option.value}
                checked={field.value === option.value}
                onChange={field.onChange}
                id={`${name}-${index}`}
              />
            ))}
          </div>
          {fieldState.error && (
            <span className="error-message">{fieldState.error.message}</span>
          )}
        </div>
      )}
    />
  );
};

export default RadioButtonGroup;
